/*
 * Copyright (C) 2021 Quartet Health, Inc - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

import grid from '../grid';
import styled, { css } from 'styled-components';
import SpacingProps, { SpacingDefinition } from './SpacingProps';

const spacingProps = new SpacingProps('margin');
const ms = (size: number | string) => `@media screen and (min-width: ${size})`;
const mx = (point: keyof typeof grid.breakpoints) => () =>
  ms(grid.breakpoints[point]);

export interface MarginProps {
  /** margin configuration for all breakpoints
   **/
  margin?: SpacingDefinition;
  /** margin configuration for all breakpoints
   **/
  marginSm?: SpacingDefinition;
  /** margin configuration for the md breakpoint and up
   **/
  marginMd?: SpacingDefinition;
  /** margin configuration for the lg breakpoint and up
   **/
  marginLg?: SpacingDefinition;
  /** margin configuration for the xl breakpoint and up
   **/
  marginXl?: SpacingDefinition;
}

const marginPropStyles = css`
  ${spacingProps.stylesForProp('margin')}
  ${mx('sm')} {
    ${spacingProps.stylesForProp('marginSm')}
  }
  ${mx('md')} {
    ${spacingProps.stylesForProp('marginMd')}
  }
  ${mx('lg')} {
    ${spacingProps.stylesForProp('marginLg')}
  }
  ${mx('xl')} {
    ${spacingProps.stylesForProp('marginXl')}
  }
`;

export const MarginContainer = styled.div<MarginProps>`
  ${marginPropStyles}
`;

export default marginPropStyles;
